import { ResidentMedicationsTemplate } from "app/features/medications/templates/ResidentMedicationsTemplate";

export default function PendingSignaturesPage() {
  return <ResidentMedicationsTemplate />;
}
